export default {"src":"/_next/static/media/woman-thumbs-up.mono.238278a5.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};